/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoIntolleranzaUpdateDTO
 */
export interface AssistitoIntolleranzaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaUpdateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaUpdateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoIntolleranzaUpdateDTO interface.
 */
export function instanceOfAssistitoIntolleranzaUpdateDTO(value: object): value is AssistitoIntolleranzaUpdateDTO {
    return true;
}

export function AssistitoIntolleranzaUpdateDTOFromJSON(json: any): AssistitoIntolleranzaUpdateDTO {
    return AssistitoIntolleranzaUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoIntolleranzaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoIntolleranzaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoIntolleranzaUpdateDTOToJSON(value?: AssistitoIntolleranzaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

